<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-sm" role="document">
			<div class="modal-content">
				<loading :active="loading">
					<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
				</loading>
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Cambiar estado</h4>
				</div>
				<div class="modal-body">
					<template v-if="item">
						<template v-if="statuses_filter">
							<template v-if="statuses_filter.length">
								<div class="row">
									<div class="col-md-12 center">
										<template v-for="status in statuses_filter">
											<div :class="'radio radio-' + status.class" @click="changeStatus(status)">
												<input type="radio" :value="status.id" v-model="item.project_status_id">
												<label for="radio14">
													<template v-if="status.lang">
														{{ status.lang.name }}
													</template>
													<template v-else>
														{{ status.name }}
													</template>
												</label>
											</div>
										</template>
									</div>
								</div>
							</template>
						</template>
					</template>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-change-project-status'
				},

				statuses: null,
				statuses_filter: null,
				item: null,
				loading:  null,
			}
		},
		methods: {
			open(item) {
				if(item) {
					this.item = item
				}
				this.getStatuses()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getStatuses() {
				this.loading = true
				this.$http.get('admin/projects/projects/statuses')
					.then(response => {
						this.loading = false
						this.statuses = response.body
						this.loadStatuses()
					})
			},
			loadStatuses() {
				var filter = this.statuses
				/*
				if(this.item.status.id == 5) {
					filter = this.statuses.filter(function(status) {
						return status.id == 5 || status.id == 6
					})
				}*/

				this.statuses_filter = filter
			},
			changeStatus(status) {
				if(status.id != this.item.project_status_id) {
					this.loading = true
					this.$http.get('admin/projects/projects/' + this.item.id + '/change/status/' + status.id)
					.then(response => {
						this.close()
						this.loading = false
						this.$emit('reload')
					}).catch(response => {
						console.log(response)
						if(response.status == 409) {
							swal({
								title: response.statusText,
								text: response.body,
								type: 'warning',
							})
						}
						this.loading = false
						this.$emit('reload')
						this.close()
					})
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/ChangeStatus.vue